import "./image5.css";


import React from 'react';
// import IntroImg from "../assets/3.png"

const HeroImg5 = () => {
    return (
        <div className="hero-img5">
            <div className="heading">
                <h1>Projects</h1>
                <p>Here, I showcase the projects completed by both myself and our talented group.</p>
            </div>
        </div>
    );
};

export default HeroImg5